import React, { useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Alert, Box, Collapse, Paper, Stack, Typography } from '@mui/material';

import { handleExpandRowKeyDown } from './campaignScheduleTabLayout';

interface Props {
  warnings: Array<string>;
}

export default function ScheduleDoctor({ warnings }: Props) {
  const [expanded, setExpanded] = useState(false);
  const hasWarnings = warnings.length > 0;
  const toggle = () => setExpanded((current) => !current);

  return (
    <Paper sx={{ bgcolor: 'grey.100', borderRadius: 3 }} variant="outlined">
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        role={hasWarnings ? 'button' : undefined}
        spacing={2}
        sx={{ cursor: hasWarnings ? 'pointer' : 'default', px: 3, py: 2 }}
        tabIndex={hasWarnings ? 0 : undefined}
        onClick={() => hasWarnings && toggle()}
        onKeyDown={hasWarnings ? (event) => handleExpandRowKeyDown(event, toggle) : undefined}
      >
        <Stack alignItems="center" direction="row" spacing={1}>
          {hasWarnings &&
            (expanded ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />)}
          <Typography fontWeight={700} variant="h3">
            Schedule Doctor
          </Typography>
        </Stack>
        <Alert severity={hasWarnings ? 'warning' : 'success'} sx={{ py: 0 }}>
          {hasWarnings ? `${warnings.length} issue${warnings.length === 1 ? '' : 's'} detected` : 'No issues detected'}
        </Alert>
      </Stack>

      {hasWarnings && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box sx={{ px: 3, pb: 2 }}>
            <Stack spacing={1}>
              {warnings.map((warning) => (
                <Alert key={warning} severity="warning">
                  {warning}
                </Alert>
              ))}
            </Stack>
          </Box>
        </Collapse>
      )}
    </Paper>
  );
}
